import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { EdgeText, getSmoothStepPath } from 'reactflow';
import { Box } from '@mui/material';
import { ReactComponent as DeleteOutlineIcon } from '../../../../assets/common-assets/trash.svg';
import { globalClasses } from '../../utils/globalUtils';
import { classes } from './utils';
import { lightPalette } from '../../../../theme';

const CustomEdge = (props) => {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style,
    markerEnd,
    setEdges,
    setIsDraggedChanged,
  } = props;
  const [isClicked, setIsClicked] = useState(false);
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    borderRadius: 0,
  });
  const handleDelete = () => {
    setEdges((eds) => eds.filter((e) => e.id !== id));
    setIsDraggedChanged(true);
  };
  const handleClick = (event) => {
    if (!isClicked) {
      setIsClicked(!isClicked);
      event.stopPropagation();
    }
  };

  const handleClickOutside = () => {
    setIsClicked(false);
  };

  useEffect(() => {
    const handleDocumentClick = handleClickOutside;
    document.addEventListener('click', handleDocumentClick);

    return () => document.removeEventListener('click', handleDocumentClick);
  }, [isClicked]);

  return (
    <>
      <path
        id={id}
        style={{
          ...style,
          stroke: lightPalette.primary.medium,
        }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
        onClick={handleClick}
      />
      <EdgeText
        x={labelX}
        y={labelY}
        labelStyle={{ fill: lightPalette.secondaryBlack.main, fontWeight: 700 }}
        labelShowBg
        labelBgStyle={{ fill: lightPalette.secondaryWhite.main }}
        labelBgPadding={[8, 4]}
        labelBgBorderRadius={4}
      />
      {isClicked ? (
        <foreignObject width={30} height={30} x={labelX - 20} y={labelY - 20}>
          <Box
            bgcolor={lightPalette.secondaryWhite.main}
            borderRadius="50%"
            display="flex"
            justifyContent="center"
            className={globalClasses.cursorPointerClass}
          >
            <DeleteOutlineIcon
              onClick={handleDelete}
              className={classes.deleteForEdge}
            />
          </Box>
        </foreignObject>
      ) : null}
    </>
  );
};
CustomEdge.propTypes = {
  id: PropTypes.string,
  sourceX: PropTypes.number,
  sourceY: PropTypes.number,
  targetX: PropTypes.number,
  targetY: PropTypes.number,
  sourcePosition: PropTypes.string,
  targetPosition: PropTypes.string,

  style: PropTypes.object,

  markerEnd: PropTypes.object,
  setEdges: PropTypes.func,
  setIsDraggedChanged: PropTypes.func.isRequired,
};
CustomEdge.defaultProps = {
  id: '',
  sourceX: 0,
  sourceY: 0,
  setEdges: null,
  targetX: 0,
  targetY: 0,
  sourcePosition: 'left',
  targetPosition: 'right',
  style: {},
  markerEnd: null,
};
export default CustomEdge;
